import { gql } from '@apollo/client';

export const SAVE_USER_DEALER_MAPPING=()=>{
    return gql`mutation save_user_dealer_mapping($userDealerMappingInput:UserDealerMappingInput!){
        save_user_dealer_mapping(userDealerMappingInput:$userDealerMappingInput){
            message
      }
    }
  `
  };

  export const GET_USER_DEALER_MAPPING =  () => {
    return gql`
    query($user_id:Float!,$city_id:Float!,$area_id:[Int!]){ 
      get_user_dealer_mapping(user_id:$user_id,city_id:$city_id,area_id:$area_id){
        user_id
        city_id
        area_id
        dealer_ids
        }
      }
    `;
  };

  export const TASK_TIMELINE=()=>{
    return gql`
    query($task_id:Float!,$lead_id:Float){ 
        get_task_history(task_id:$task_id,lead_id:$lead_id)
      }
    `;
  };

  export const TASK_LIST_QUERY = () => {
    return gql
    `query($task_type:String!,$task_status:String,$source:String!,
    $user_id:Int!,$role_ids:[Int!],$from_date:String,$to_date:String,$page_num:Int,$search_text:String,$lead_assigned_to:Int,$area_id:Int,$is_verified:String,$is_distributed:String,$page_type: String,$lead_assigned_to_ids:[Int!],$is_archived:String){
      task_list_web(inputparams:{source:$source,user_id:$user_id,role_ids:$role_ids,
        task_type:$task_type,task_status:$task_status,from_date:$from_date,to_date:$to_date,page_num:$page_num,search_text:$search_text,lead_assigned_to:$lead_assigned_to,area_id:$area_id,is_verified:$is_verified,is_distributed:$is_distributed,page_type:$page_type,lead_assigned_to_ids:$lead_assigned_to_ids,is_archived:$is_archived}){
          task_list{
            lead_id
            task_id
            make_name
            model_name
            variant_name
            make_year
            loan_value
            dealer_id
            dealer_name
            area
            lead_assigned_to
            task_date
            bpkp_collected_date
            bpkp_inspected_date
            bpkp_distributed_date
            auditor_completed_date
            distribution_completed_date
            collection_completed_date
            task_status
            lead_status
            remaining_principal_amount
            collected_by
            bm_id
            bm_name
            dealer_id
            dealer_name 
            bpkb_number
            plate_number
            distributed_to
            is_loan_overdue
            is_show_ptp_date
            is_ptp_date_mandatory
            collection_comment
            created_date
          }
          pagination{
            totalpage
            totalrecords
            prevpage
            nextpage
            page_size
          }
          tabs{
            active
            schedule
            collected
            inspected
            completed
            rejected
            in_stock
            distributed
            closed
            pending
            failed
            archived
          }
      }
  }`;
}

export const RESCHEDULE_TASK_DATE = () => {
  return gql
  `mutation($rescheduleTaskInput:ReScheduleTaskInput! ){
    reschedule_task(rescheduleTaskInput:$rescheduleTaskInput){
    message
  }
}`;
}

export const ASSIGN_TASK=()=>{
  return gql`
    mutation assign_task($assignTaskInput:OpseeAssignTaskInput!){
      assign_task(assignTaskInput:$assignTaskInput){
          message
      }
    }
  `;
}

export const SAVE_CLOSE_TASK_DETAILS=()=>{
  return gql`mutation save_opsee_task_details($opseeTaskDetailsInput:OpseeTaskDetailsInput!){
      save_opsee_task_details(opseeTaskDetailsInput:$opseeTaskDetailsInput){
          message
    }
  }
`
};

export const SAVE_CLOSE_INSPECTOR_TASK_DETAILS=()=>{
  return gql`mutation save_inspection_task_details($opseeInspectionTaskDetailsInput:OpseeInspectionTaskDetailsInput!){
      save_inspection_task_details(opseeInspectionTaskDetailsInput:$opseeInspectionTaskDetailsInput){
          message
    }
  }
`
};

export const REJECT_TASK=()=>{
  return gql`mutation reject_task($rejectTaskInput:CommonOpseeInput!){
      reject_task(rejectTaskInput:$rejectTaskInput){
          message
    }
  }
`
};

export const EXPORT_TASK_LIST_QUERY = () => {
  return gql
  `mutation($task_type:String!,$task_status:String!,$source:String!,
  $user_id:Int!,$role_ids:[Int!],$from_date:String,$to_date:String,$page_num:Int,$search_text:String,$lead_assigned_to:Int,$area_id:Int,$is_verified:String){
    export_task(exportTaskInput:{source:$source,user_id:$user_id,role_ids:$role_ids,
      task_type:$task_type,task_status:$task_status,from_date:$from_date,to_date:$to_date,page_num:$page_num,search_text:$search_text,lead_assigned_to:$lead_assigned_to,area_id:$area_id,is_verified:$is_verified}){
        message
    }
}`;
};

export const HANDOVER_DOCS=()=>{
  return gql`mutation handover_docs($handOverDocsInput: HandOverDocsInput!){
      handover_docs(handOverDocsInput:$handOverDocsInput){
          message
    }
  }
`
};

export const CLOSE_AUDIT_TASK=()=>{
  return gql`mutation save_check_out_details($checkOutFormInput: CheckOutFormInput!){
      save_check_out_details(checkOutFormInput:$checkOutFormInput){
          message
    }
  }
`
};

export const RUNNER_MAPPING_LIST=()=>{
  return gql
    `query($source:String!,$user_id:Int!,$page_num:Float,$filter_user:Float,$filter_dealer:Float,$filter_role:Float,$filter_city:Float,$filter_area:Float,$filter_status:String){
      runner_mapping_list(runnerListInput:{source:$source,user_id:$user_id,page_num:$page_num,filter_user:$filter_user,
        filter_dealer:$filter_dealer,filter_role:$filter_role,filter_city:$filter_city,filter_area:$filter_area,filter_status:$filter_status}){
          runner_list {
            user_id
            city_id
            area_id
            user_name
            city
            area
            role_assigned
            user_status
          } 
          pagination{
            totalpage
            totalrecords
            prevpage
            nextpage
            page_size
          }
      }
  }`;
};

export const SEND_REMINDER=()=>{
  return gql`mutation send_reminder($reminderInput: CommonOpseeInput!){
      send_reminder(reminderInput:$reminderInput){
          message
    }
  }
`
};

export const EXPORT_RUNNER_MAPPING_REPORT=()=>{
  return gql`query($runnerListInput:OpseeRunnerListInput!) {
    runner_mapping_export(runnerListInput:$runnerListInput) {
      runner_list {
          user_name
          city
          area
          role_assigned
          user_status
        } 
    }
  }`
}

export const REVOKE_TASK=()=>{
  return gql`mutation revoke_task($revokeTaskInput:CommonOpseeInput!){
      revoke_task(revokeTaskInput:$revokeTaskInput){
          message
    }
  }
`
};

export const TASK_VIEW_LIST= () => gql`
  query task_view_list($taskViewInput: TaskViewInput!) {
    task_view_list(taskViewInput: $taskViewInput) {
      count_data {
        text
        value
        filter_params {
          task_status
        }
      }
      task_list {
        id
        customer_id
        survey_type_id
        pb_full_name
        pb_mobile
        cb_full_name
        cb_mobile
        name
        address
        created_date
        lead_type
        is_acknowledged
        show_vehicle_inspection_popup
        doc_urls
        assigned_to
        assigned_acknowledged_tat
        acknowledged_completed_tat
        reschedule_date
        other_reason
      }
      pagination {
        totalpage
        totalrecords
        prevpage
        nextpage
        page_size
      }
      tabs {
        unassigned
        assigned_unacknowledged
        assigned_acknowledged
        completed
        overdue
        rejected
      }
      rejection_reasons
    }
  }
`;

export const ASSIGN_OPSEE_TASK = () => gql`
  mutation assignTask($assignTaskInput: OpseeAssignTaskInputPH!) {
    assign_opsee_task(assignTaskInput: $assignTaskInput) {
      message
      status
    }
  }
`;

export const CUSTOMER_VIEW_LIST= () => gql`
  query customer_view_list($customerViewInput: TaskViewInput!) {
    customer_view_list(customerViewInput: $customerViewInput) {
      customer_list {
        id
        lead_type
        pb_full_name
        pb_mobile
        cb_full_name
        cb_mobile
        created_date
        total_tasks
        completed_tasks
        overall_status
        created_to_completed_tat
        surveys {
          survey_type_id
          survey_name
          is_completed
        }
      }
      pagination {
        totalpage
        totalrecords
        prevpage
        nextpage
        page_size
      }
      rejection_reasons
    }
  }
`;

export const SAVE_CUSTOMER_DETAILS = () => gql`
  mutation addCustomerDetails($createCustomerInput: CreateCustomerInput!) {
    add_customer_details(createCustomerInput: $createCustomerInput) {
      message
      status
    }
  }
`;

export const GET_OPSEE_FORM_FIELDS = () => gql`
  query get_opsee_form_fields($survey_type_id: Float!) {
    get_opsee_form_fields(
      documentListInput: { survey_type_id: $survey_type_id }
    ) {
      sections {
        id
        key
        title
        fields {
          id
          name
          label
          type
          keyboard_type
          is_required
          is_enable
          is_show
          value
          prefix
          field_show
          options {
            id
            label
            value
            custom
          }
          error_msg
          validation {
            regex
            min_length
            max_length
          }
          parent_depedencies
          actions
          child_depedencies
          doc_id
          bg_color_color
        }
      }
    }
  }
`;

export const GET_OPSEE_DOCUMENT_LIST = () => gql`
  query getOpseeDocumentList($survey_type_id: Int!) {
    masterdata(
      master_data: ["document_list_opsee"]
      api_called_by: opsee
      survey_type_id: $survey_type_id
    ) {
      document_list_opsee {
        id
        name
        is_required
        is_required_app
        max_upload
        min_upload
        sort_number
        doc_icon_url
        bg_color_color
      }
    }
  }
`;

export const GET_CUSTOMER_DETAILS = () => gql`
  query CustomerDetails($customerDetailsInput: CustomerDetailsInput!) {
    customer_details(customerDetailsInput: $customerDetailsInput) {
      id
      lead_type
      pb_full_name
      pb_mobile
      is_co_borrower_enable
      cb_full_name
      cb_mobile
      status
      created_by
      created_by_name
      request_created
      overall_status

      surveys {
        id
        customer_id
        survey_type_id
        name
        address
        province_id
        city_id
        other_instruction
        doc_urls
        assigned_to
        assigned_to_name
        task_status
        assigned_date
        acknowledged_date
        completed_date
        rejection_reasons
        survey_status

        surveyType {
          id
          name
        }

        survey_docs {
          id
          doc_id
          task_id
          survey_type_id
          doc_path
          doc_path_watermark
          comment
        }
      }
      survey_details
      doc_master
    }
  }
`;

export const UPDATE_TASK_STATUS = () => gql`
  mutation updateTask($updateTaskInput: UpdateTaskInput!) {
    update_task_status(updateTaskInput: $updateTaskInput) {
      message
      status
    }
  }
`;

export const UPDATE_CUSTOMER_STATUS = () => gql`
  mutation updateCustomer($updateCustomerInput: UpdateCustomerInput!) {
    update_customer_status(updateCustomerInput: $updateCustomerInput) {
      message
      status
    }
  }
`;

export const GET_USER_LEAVE_DETAILS = () => {
  return gql`query GetUserLeaveDetails($userLeaveDetailsInput: UserLeaveDetailsInput!) {
    get_user_leave_details(userLeaveDetailsInput: $userLeaveDetailsInput) {
      user_id
      leave_start_date
      leave_end_date
      comment
    }
  }`;
};

export const MARK_LEAVE = () => {
  return gql`mutation MarkLeave($markLeaveInput: MarkLeaveInput!) {
    mark_leave(markLeaveInput: $markLeaveInput) {
      message
      status
    }
  }`;
};

export const ASSIGN_INSPECTION_TASK = () => {
  return gql`mutation AssignInspectionTask($input: AssignInspectionTaskInput!) {
    assign_inspection_task(input: $input)
  }`;
};

export const INSPECTION_LIST_QUERY = () => {
  return gql`query inspection_list($input: InspectionListInput!) {
    inspection_list(input: $input)
  }`;
};
